import { FavoriteConfiguratorDto } from '../dto/save-configurator.dto'
import { Component, PowerMeter, Product, ShopSystemConfiguration } from 'src/State/ShopSystemConfiguration/ShopSystemConfigurationModel'

const systemConfigurationFromModelToDtoTransformer = (dto: ShopSystemConfiguration): FavoriteConfiguratorDto => {
  return {
    name: dto.label || '',
    configuration: {
      configuratorId: dto.configuration?.configuratorId || '',
      components: (dto.configuration?.components || []).map((component: Component) => ({
        id: component.id,
        products: (component.products || []).map((product: Product) => ({
          id: product.id,
          qty: product.qty,
        })),
      })),
      powerMeters: (dto.configuration?.powerMeters || []).map((powerMeter: PowerMeter) => ({
        id: powerMeter.id,
        powerMeterId: powerMeter.powerMeterId,
        powerConverterId: powerMeter.powerConverterId,
      })),
      retrofitBattery: dto.configuration?.retrofitBattery,
      smartMeter: dto.configuration?.smartMeter,
    },
  }
}

export default systemConfigurationFromModelToDtoTransformer
